export default __webpack_public_path__ + "static/media/top.ce967c90.png";